// Shared constants for the Legend Sports Cave Stream Deck plugin (ADR 0024).
// The plugin source lives in streamdeck-plugin/; the packaged file is served
// as a static asset from the web app so a broadcaster can install it in a click.

/** Reverse-DNS plugin id — matches the plugin's manifest UUID. */
export const PLUGIN_ID = "com.legendsportscave.deck";

/** Where the packaged .streamDeckPlugin is served (web/public/downloads/). */
export const PLUGIN_DOWNLOAD_PATH = "/downloads/legend-sports-cave.streamDeckPlugin";
